import { render, staticRenderFns } from "./SmsSendingHistory.vue?vue&type=template&id=6087758c&scoped=true&"
import script from "./SmsSendingHistory.vue?vue&type=script&lang=js&"
export * from "./SmsSendingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087758c",
  null
  
)

export default component.exports